/*global Modernizr */
/*jslint browser:true */

(function() {
  'use strict';

  var sibling_dropdown_container = document.querySelector('.sibling-dropdown-container');
  if(sibling_dropdown_container) {
    var sibling_dropdown_trigger = sibling_dropdown_container.firstElementChild;

    // Set aria expanded on mouse enter
    sibling_dropdown_trigger.addEventListener('mouseenter', (e) => {
      sibling_dropdown_trigger.setAttribute('aria-expanded', 'true');
    });

    // Remove aria expanded on mouse out
    sibling_dropdown_trigger.addEventListener('mouseleave', (e) => {
      sibling_dropdown_trigger.setAttribute('aria-expanded', 'false');
    });

    // Allow keyboard to open mobile menu
    sibling_dropdown_trigger.addEventListener('keydown', (e) => {
      // Open menu with enter, space, up, or down arrow
      if(e.code === 'Enter' || e.code === 'Space' || e.code === 'ArrowUp' || e.code === 'ArrowDown') {
        e.preventDefault();

        if(sibling_dropdown_container.classList.contains('open')) {
          sibling_dropdown_container.classList.remove('open');
          sibling_dropdown_trigger.setAttribute('aria-expanded', 'false');
        } else {
          sibling_dropdown_container.classList.add('open');
          sibling_dropdown_trigger.setAttribute('aria-expanded', 'true');

          setTimeout(function(){
            var anchors = sibling_dropdown_container.querySelectorAll('ul a'),
                select_anchor = anchors[0];

            if(e.code === 'ArrowUp') {
              select_anchor = anchors[anchors.length - 1];
            }

            if(select_anchor) {
              select_anchor.focus();
            } else {
              sibling_dropdown_container.querySelector('ul').focus();
            }
          }, 350);
        }
      }
    });

    sibling_dropdown_container.querySelector('.sub-menu-container').addEventListener('keydown', (e) => {
      var anchors = Array.from(sibling_dropdown_container.querySelectorAll('ul a:not(.overview-link)'));

      var current_anchor_index = anchors.indexOf(e.target);

      // On key escape
      if(e.code === 'Escape') {
        e.preventDefault();
        sibling_dropdown_container.classList.remove('open');
        sibling_dropdown_trigger.setAttribute('aria-expanded', 'false');
        sibling_dropdown_trigger.focus();
      }

      // On key up
      if(e.code === 'ArrowUp') {
        e.preventDefault();

        if(current_anchor_index === 0) {
          anchors[anchors.length - 1].focus();
        } else {
          anchors[current_anchor_index - 1].focus();
        }
      }

      // On key down
      if(e.code === 'ArrowDown') {
        e.preventDefault();

        if(current_anchor_index === (anchors.length - 1)) {
          anchors[0].focus();
        } else {
          anchors[current_anchor_index + 1].focus();
        }
      }

      // Key home, go to first anchor
      if(e.code === 'Home') {
        e.preventDefault();
        anchors[0].focus();
      }

      // Key end, go to last anchor
      if(e.code === 'End') {
        e.preventDefault();
        anchors[anchors.length - 1].focus();
      }
    });

    sibling_dropdown_trigger.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      sibling_dropdown_container.classList.toggle('open');

      if(sibling_dropdown_container.classList.contains('open')) {
        sibling_dropdown_trigger.setAttribute('aria-expanded', 'true');
      } else {
        sibling_dropdown_trigger.setAttribute('aria-expanded', 'false');
      }
    });

    document.body.addEventListener('click', () => {
      sibling_dropdown_container.classList.remove('open');
      sibling_dropdown_trigger.setAttribute('aria-expanded', 'false');
    });
  }
}());